import { firestoreDocumentByPath, update } from '../firebase/firestore';

const MODULE_PREFIX = 'crud';
const ACTION_UPDATE_DOCUMENT = 'updateDocument';

const actions = {
  [ACTION_UPDATE_DOCUMENT]: async (_, { documentPath, updateData }) => {
    console.log('ACTION_UPDATE_DOCUMENT', documentPath, updateData);
    try {
      await update(
        firestoreDocumentByPath(documentPath),
        updateData,
      );
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  },
};

export default {
  namespaced: true,
  actions,
};

export const types = {
  actions: {
    updateDocument: `${MODULE_PREFIX}/updateDocument`,
  },
};
